import { List } from 'immutable'
import { Store } from 'redux'

import { AVAILABLE_STEP_COMPONENTS } from 'routes/Signup/constants/AvailableStepComponents'
import { SignupSteps } from 'routes/Signup/constants/SignupSteps'
import { signupConfig } from 'routes/Signup/signupConfig'
import { getIsOneThreeFivePortionsEnabled } from 'selectors/features'

/**
 * Returns steps for signup. Steps without a component are filtered out.
 * @param store - application redux store
 */
export const getSignupSteps = async (store: Store): Promise<List<SignupSteps>> => {
  const isOneThreeFivePortionsEnabled = await getIsOneThreeFivePortionsEnabled(store.getState())

  const resultSteps: List<SignupSteps> = List(
    isOneThreeFivePortionsEnabled ? signupConfig.stepsWithPortionSizes : signupConfig.defaultSteps,
  )

  /**
   * Filter out steps that do not have a component.
   */
  return resultSteps.filter(
    (step) => !!AVAILABLE_STEP_COMPONENTS[step as SignupSteps],
  ) as List<SignupSteps>
}
